import { ApiStage } from 'core/constants/enums/ApiStages.ts';
import { CanvasAssetType } from 'core/constants/enums/CanvasAssetType.ts';

const getShallowCopy = (value) => {
	if (value === null) return null;
	if (Array.isArray(value)) return [...value];
	if (typeof value === 'object') return { ...value };
	return value;
};

const getAssetTypeInitialState = (initialValue, initialValueMap = {}) =>
	Object.values(CanvasAssetType).reduce(
		(previousValue, currentValue) => ({
			...previousValue,
			[currentValue]: initialValueMap[currentValue] ?? getShallowCopy(initialValue),
		}),
		{},
	);

const initialState = {
	assets: getAssetTypeInitialState([]),
	assetsMap: {},
	assetsCurrentPage: getAssetTypeInitialState(1),
	assetsNextTs: getAssetTypeInitialState(undefined),
	assetsHasNextPage: getAssetTypeInitialState(true),
	assetsListApiStage: getAssetTypeInitialState(ApiStage.IDLE),
	assetsUploadApiStage: getAssetTypeInitialState(ApiStage.IDLE),
	assetsDeleteApiStage: getAssetTypeInitialState(ApiStage.IDLE),
	isAssetLibraryModalOpen: getAssetTypeInitialState(false),
	assetLibraryModalDetails: getAssetTypeInitialState(null),
	assetLibraryModalType: CanvasAssetType.IMAGE,
	uploadedAsset: getAssetTypeInitialState(null),
	isTemplateAssetSelected: false,
	isTemplateModalOpen: false,
};

export const assetsInitialState = initialState;
